export const DELETE_CONFIRMATION_TEXT = "DELETE MY ACCOUNT";

export function canSubmitDeletionRequest({
  confirmationText,
  twoFactorEnabled,
  twoFactorCode,
}) {
  if (confirmationText !== DELETE_CONFIRMATION_TEXT) return false;
  if (twoFactorEnabled && (!twoFactorCode || twoFactorCode.trim().length < 6)) {
    return false;
  }
  return true;
}
